import LabelValuePair from "./LabelValuePair";

export default class LinkedLabelValuePair<TLabel,TValue> extends LabelValuePair<TLabel,TValue> {
	constructor(data?: any) {
		super(data);
		if (data?.children?.length) {
			this.children = data.children.map((_: any) => new LinkedLabelValuePair(_));
		}
	}

	children?: Array<LinkedLabelValuePair<TLabel,TValue>>;
}